import { MrbBaseListViewStore } from "mrb/core";
import { MrbGridViewStore } from "mrb/components/grid";
import { NakiNigunAnalyticsService } from "common/services";
import { computed, makeObservable } from "mobx";

class NakiNigunListenersListViewStore extends MrbBaseListViewStore {
    @computed get isInitalized() {
        return this.gridStore.dataInitialized;
    }

    constructor(rootStore, nakiNigunListenersListViewStore) {
        super(rootStore, {});
        makeObservable(this);
        this.nakiNigunListenersListViewStore = nakiNigunListenersListViewStore;
        this.routeStore = this.nakiNigunListenersListViewStore.routeStore;
        this.service = rootStore.createApplicationService(NakiNigunAnalyticsService);

        this.setGridStore(
            new MrbGridViewStore(this.rootStore, this.queryUtility, {
                generateKey: (item) => item.id,
                mapper: (item, i) => {
                    return {
                        ...item,
                        coverImageUrl: this.createCoverImageUrl(item),
                        position: i + 1,
                    };
                },
            })
        );
        this.createCoverImageUrl = this.createCoverImageUrl.bind(this);
    }

    async onInit() {
        this.gridStore.suspend();
        const response = await this.service.getNakiNigunListenersStats();
        this.gridStore.setData(response.data);
        this.gridStore.resume();
    }

    createCoverImageUrl(item) {
        if (item && item.coverImageId) {
            return this.rootStore.coverImageFactory.createNakiNigunAlbumCoverImageUrl(item.coverImageId, 150, 150);
        }
        return null;
    }
}

export default NakiNigunListenersListViewStore;
